const BOARD_STORAGE_KEY = 'docanban:last-board-id';

function canUseWindow() {
  return typeof window !== 'undefined';
}

function getCurrentUrl() {
  return new URL(window.location.href);
}

export function buildBoardUrl(boardId: string) {
  return `/app/board/${encodeURIComponent(boardId)}`;
}

export function getBoardIdFromLocation() {
  if (!canUseWindow()) return null;

  const pathname = window.location.pathname.replace(/\/+$/, '');
  const boardMatch = pathname.match(/^\/app\/board\/([^/]+)$/);

  if (boardMatch?.[1]) {
    return decodeURIComponent(boardMatch[1]);
  }

  const boardId = getCurrentUrl().searchParams.get('board');
  return boardId || null;
}

export function getStoredBoardId() {
  if (!canUseWindow()) return null;

  try {
    return window.localStorage.getItem(BOARD_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function storeBoardId(boardId: string) {
  if (!canUseWindow()) return;

  try {
    window.localStorage.setItem(BOARD_STORAGE_KEY, boardId);
  } catch {
    // Ignore storage failures. URL routing still works.
  }
}

export function clearStoredBoardId() {
  if (!canUseWindow()) return;

  try {
    window.localStorage.removeItem(BOARD_STORAGE_KEY);
  } catch {
    // Ignore storage failures. They shouldn't block navigation.
  }
}

function updateBoardUrl(boardId: string, mode: 'push' | 'replace') {
  if (!canUseWindow()) return;

  const url = getCurrentUrl();
  url.pathname = buildBoardUrl(boardId);
  url.searchParams.delete('board');

  const nextUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', nextUrl);
}

export function pushBoardUrl(boardId: string) {
  updateBoardUrl(boardId, 'push');
}

export function replaceBoardUrl(boardId: string) {
  updateBoardUrl(boardId, 'replace');
}
